import type { ApplicationContext } from '@hc-frontend/core-context';
import { createErrorOperationResult } from '@hc-frontend/core-utils-business-operation';

import { UpdateProspectSeniorCheckParameters } from '../../entities';
import type {
  UpdateProspectSeniorCheckRepository,
  UpdateProspectSeniorCheckResult,
} from '../../repositories';

export type UpdateProspectSeniorCheckUseCase = (
  parameters: UpdateProspectSeniorCheckParameters,
) => Promise<UpdateProspectSeniorCheckResult>;

type UpdateProspectSeniorCheckFactoryParams = Pick<
  ApplicationContext,
  'log'
> & {
  updateProspectSeniorCheck: UpdateProspectSeniorCheckRepository;
};

export function updateProspectSeniorCheckFactory({
  updateProspectSeniorCheck,
  log,
}: UpdateProspectSeniorCheckFactoryParams): UpdateProspectSeniorCheckUseCase {
  return async (parameters) => {
    const convertResult =
      UpdateProspectSeniorCheckParameters.safeParse(parameters);

    if (!convertResult.success) {
      log({
        type: 'error',
        context: 'server',
        message: 'failedToUpdateProspectSeniorCheck',
        data: {
          rootCause: convertResult.error,
        },
      });
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToTransformSeniorCheck',
            rootCause: convertResult.error,
          },
        ],
      });
    }

    const result = await updateProspectSeniorCheck.update(convertResult.data);

    if (!result.success) {
      log({
        context: 'server',
        type: 'error',
        message: result.errors[0].code,
        data: {
          rootCause: result.errors[0].rootCause,
        },
      });
    }

    return result;
  };
}
